// extracted by mini-css-extract-plugin
export default {"ProductList":"ProductList_ProductList__jXbij","name":"ProductList_name__mzYdl","cost":"ProductList_cost__kCHx9","category":"ProductList_category__xiXtm"};